import { downloadBlobFile } from '@/@core/utils/utils';

export default class ProviderService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllProviders(args) {
    return this.axiosIns.get(this.serviceConfig.providers, { params: args });
  }

  getProvider(id) {
    return this.axiosIns.get(`${this.serviceConfig.providers}/${id}`);
  }

  createProvider(args) {
    return this.axiosIns.post(this.serviceConfig.providers, args);
  }

  editProvider(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.providers}/${id}`, args);
  }

  deleteProvider(id) {
    return this.axiosIns.delete(`${this.serviceConfig.providers}/${id}`);
  }

  setProviderRegionModelType(id, args) {
    return this.axiosIns.patch(`${this.serviceConfig.providers}/${id}/region-model-type`, args);
  }

  getRegion(providerId, regionId) {
    return this.axiosIns.get(`${this.serviceConfig.providers}/${providerId}/regions/${regionId}`);
  }

  createProviderRegion(args) {
    return this.axiosIns.post(`${this.serviceConfig.regions}`, args);
  }

  editProviderRegion(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.regions}/${id}`, args);
  }

  deleteProviderRegion(id) {
    return this.axiosIns.delete(`${this.serviceConfig.regions}/${id}`);
  }

  getAllFees(providerId, args) {
    return this.axiosIns.get(`${this.serviceConfig.providers}/${providerId}/additional-fees`, {
      params: args
    });
  }

  getFee(providerId, feeId) {
    return this.axiosIns.get(
      `${this.serviceConfig.providers}/${providerId}/additional-fees/${feeId}`
    );
  }

  createProviderFee(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.providers}/${id}/additional-fees`, args);
  }

  editProviderFee(id, feeId, args) {
    return this.axiosIns.put(
      `${this.serviceConfig.providers}/${id}/additional-fees/${feeId}`,
      args
    );
  }

  deleteProviderFee(id, feeId) {
    return this.axiosIns.delete(`${this.serviceConfig.providers}/${id}/additional-fees/${feeId}`);
  }

  getProviderPrices(args) {
    return this.axiosIns.post('/api/v1/provider/offers', args);
  }

  getAllRegions(id, args) {
    return this.axiosIns.get(`${this.serviceConfig.providers}/${id}/regions`, { params: args });
  }

  getProviderPackageTypes(providerId) {
    return this.axiosIns.get(
      `${this.serviceConfig.providers}/${providerId}/feature/packaging-types`
    );
  }

  createProviderPricing(importId) {
    return this.axiosIns.post(`${this.serviceConfig.providerPrices}/import/${importId}/confirm`);
  }

  previewRegionPricing({
    file,
    providerId,
    packageType,
    packageTypeValue,
    transportType,
    transportDirection,
    activeAt,
    activeUntil
  }) {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('packageType', packageType);
    formData.append('packageTypeValue', packageTypeValue);
    formData.append('transportType', transportType);
    formData.append('transportDirection', transportDirection);
    formData.append('activeAt', activeAt);
    formData.append('activeUntil', activeUntil);
    return this.axiosIns.post(
      `${this.serviceConfig.providerPrices}/import/${providerId}`,
      formData
    );
  }

  downloadPricingTemplate(providerId) {
    return this.axiosIns
      .get(`${this.serviceConfig.providerPrices}/download-template/${providerId}`, {
        responseType: 'blob'
      })
      .then(response => {
        const reader = new FileReader();
        reader.onload = () => {
          // eslint-disable-next-line no-console
          console.log(reader.result); // Inspect this to ensure it's binary data
        };
        downloadBlobFile({ file: response, fileName: 'Cost Table Template.xlsx' });
      });
  }

  getPricingByPackageType({ providerId, packageType, packageValue }) {
    return this.axiosIns.get(
      `${this.serviceConfig.providers}/${providerId}/${packageType}/${
        packageValue || 'Butün Paket Türleri'
      }`
    );
  }

  getProviderSpecialServices(provider) {
    return this.axiosIns.get(`${this.serviceConfig.providerSpecialServices}`, {
      params: {
        provider
      }
    });
  }

  saveProviderSpecialServices(specialServiceId, args) {
    return this.axiosIns.put(
      `${this.serviceConfig.providerSpecialServices}/${specialServiceId}`,
      args
    );
  }

  getProviderInstructionDetails(providerId) {
    return this.axiosIns.get(`/api/v1/provider-action-support?provider=${providerId}`);
  }

  updateProviderInstruction(instructionId, args) {
    return this.axiosIns.put(`/api/v1/provider-action-support/${instructionId}`, {
      action_price: args.actionPrice
    });
  }

  getSalePricesInstructions() {
    return this.axiosIns.get(`/api/v1/customers/action-fees/all`);
  }

  getSalePricesInstructionsDetail(providerId, customerId) {
    return this.axiosIns.get(`/api/v1/customers/${customerId}/action-fees/${providerId}`);
  }

  updateSalePricesInstructions(providerId, customerId, args) {
    return this.axiosIns.put(`/api/v1/customers/${customerId}/action-fees/${providerId}`, args);
  }

  getAllCustomerReturnFees() {
    return this.axiosIns.get(`${this.serviceConfig.providers}/return-fees/all`);
  }

  getCustomerReturnFee(providerId) {
    return this.axiosIns.get(`${this.serviceConfig.providers}/${providerId}/return-fees`);
  }

  createCustomerReturnFee(providerId, args) {
    return this.axiosIns.post(`${this.serviceConfig.providers}/${providerId}/return-fees`, args);
  }

  editCustomerReturnFee(providerId, providerReturnFeeId, args) {
    return this.axiosIns.put(
      `${this.serviceConfig.providers}/${providerId}/return-fees/${providerReturnFeeId}`,
      args
    );
  }

  deleteCustomerReturnFee(providerId, providerReturnFeeId) {
    return this.axiosIns.delete(
      `${this.serviceConfig.providers}/${providerId}/return-fees/${providerReturnFeeId}`
    );
  }
}
